export const SET_MESSAGE = 'SET_MESSAGE';
export const REDUX_FORM_DATA = 'REDUX_FORM_DATA';
export const SET_IS_MOBILE_BREAKPOINT = 'SET_IS_MOBILE_BREAKPOINT';

export default {
    SET_MESSAGE,
    REDUX_FORM_DATA,
    SET_IS_MOBILE_BREAKPOINT
}